<script lang="ts" setup>
import { ref } from 'vue';
import { getMonthsInYear } from '@/utilities/dateutils';
import { ButtonComp, DateComp } from '@/components';

const props = defineProps<{
    modelValue: Date;
}>();

const emits = defineEmits(['update:modelValue']);

const displayMonth = ref(new Date(props.modelValue));

const months = getMonthsInYear();
</script>

<template>
    <div class="dateinput-grid grid-months">
        <ButtonComp
            button-type="Secondary"
            v-for="month in months"
            :key="month.getTime()"
            class="text-center px-1 text-capitalize"
            @click="
                displayMonth.setMonth(month.getMonth());
                emits('update:modelValue', displayMonth);
            "
        >
            <DateComp
                :value="month"
                format="MONTHLONG"
            />
        </ButtonComp>
    </div>
</template>
